export type SiteMode = 'free' | 'paid';

function resolveSiteMode(): SiteMode {
  const rawMode = import.meta.env.VITE_SITE_MODE?.trim().toLowerCase();
  return rawMode === 'paid' ? 'paid' : 'free';
}

const mode = resolveSiteMode();

export const siteConfig = {
  mode,
  isFreeMode: mode === 'free',
  isPaidMode: mode === 'paid',
  brandName: mode === 'paid' ? 'Lite' : 'Default',
  features: {
    showLegacyHome: mode === 'free',
    showLiteAsHome: mode === 'paid',
    enableLiteRoute: true,
    enableCareerRoute: true,
  },
} as const;

